import React from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'

export interface MainNavItemProps {
    href: string
    name: string
    current?: boolean
}

const classNames = (...classes: string[]) => {
    return classes.filter(Boolean).join(' ')
}

const FooterNavItem: React.FC<MainNavItemProps> = ({ href, name, current = false }) => {
    const router = useRouter()

    return (
        <Link href={href} key={name}>
            <a
                key={name}
                href={href}
                title={name}
                className={classNames(
                    router.asPath === href
                        ? 'text-mariner-700/75 hover:text-mariner-700/75'
                        : 'border-transparent text-gray-500 text-mariner-500 hover:text-mariner-700/75',
                    'inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium hover:no-underline'
                )}
                aria-current={current ? 'page' : undefined}
            >
                {name}
            </a>
        </Link>
    )
}

export default FooterNavItem
